var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMarkerPin04 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#marker-pin-04_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#B68300",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M3.334 9.524c-1.234.545-2 1.304-2 2.143 0 1.657 2.985 3 6.667 3s6.666-1.343 6.666-3c0-.84-.765-1.598-2-2.143m-.666-4.19c0 2.709-3 4-4 6-1-2-4-3.291-4-6a4 4 0 1 1 8 0m-3.334 0a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "marker-pin-04_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgMarkerPin04;